import type { SVGProps } from 'react';
import { memo } from 'react';

import { SVG_STOROKE_SIZE } from '@/data/shared/constant';

import { IconSizeType } from '@/types/icon';

interface SvgIconProps extends SVGProps<SVGSVGElement> {
  size: IconSizeType;
}
const SvgIconMapMarkerSharpFill = ({ size = 24, ...props }: SvgIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    fill="none"
    viewBox="0 0 24 24"
    className="svgr-icon-component"
    strokeWidth={SVG_STOROKE_SIZE[size]}
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M4.998 10.4c0-4.026 3.074-7.4 7-7.4s7 3.374 7 7.4c0 2.064-.88 3.87-2.064 5.51-.987 1.368-2.251 2.704-3.502 4.026l-.704.747-.73.779-.73-.779a225.04 225.04 0 0 0-.704-.746c-1.25-1.323-2.514-2.66-3.501-4.027-1.185-1.64-2.065-3.446-2.065-5.51Zm7.003 1.599a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z"
      clipRule="evenodd"
    />
  </svg>
);
const Memo = memo(SvgIconMapMarkerSharpFill);
export default Memo;
